import './numericInput.css';

interface NumericInputProps {
    max?: number; // default 5
    value?: number | null;
    onChange: (value: number) => void;
    error?: boolean;
}

export default function NumberInput({ value, onChange }: NumericInputProps) {
    const increment = () => {
        if (!value) return;
        const newValue = value + 0.5;

        if (newValue < 1 || newValue > 5) return;
        onChange(newValue);
    };

    const decrement = () => {
        if (!value) return;
        const newValue = value - 0.5;

        if (newValue < 1 || newValue > 5) return;
        onChange(newValue);
    };

    return (
        <div style={{ position: 'relative' }}>
            <input
                type="number"
                value={value || ''}
                readOnly
                onWheelCapture={e => e.preventDefault()}
            />

            <div
                style={{
                    position: 'absolute',
                    right: '0px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '3px',
                }}
            >
                <button
                    type="button"
                    onClick={increment}
                    className="numeric-input-button"
                >
                    ▲
                </button>

                <button
                    type="button"
                    onClick={decrement}
                    className="numeric-input-button red"
                >
                    ▼
                </button>
            </div>
        </div>
    );
}
